import { EntityTypes } from '../Edit';
import { EntityWithDetails } from '~/repositories/EntityRepository';

export enum Mode {
  Live = 'live',
  Sandbox = 'sandbox',
}

export interface RootEntityOutletContext {
  mode: Mode;
  formType: EntityTypes | undefined;
  sandboxRootEntity: EntityWithDetails | null | undefined;
  liveRootEntity: EntityWithDetails | null | undefined;
  isSandboxLoading: boolean;
  isLiveLoading: boolean;
  isSandbox: boolean;
  handleSubmit: () => void;
  setFormType: (type: EntityTypes) => void;
  resetForm: (entityType: EntityTypes, entity: EntityWithDetails | null) => void;
}
